var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Log } from '../../../../log';
import { createUdpSocket } from './UdpSocket';
const amxBeaconPort = 9131;
const amxBeaconMulticastAddress = '239.255.250.250';
const debugBeacons = false;
export class AmxBeaconListener {
    constructor() {
        this.beacons = {};
        this.log = Log.channel('AmxBeaconListener');
        this.errorCallback = this.errorCallback.bind(this);
        this.messageCallback = this.messageCallback.bind(this);
    }
    static getBeacons() {
        return Object.values(AmxBeaconListener.getInstance().beacons);
    }
    static getInstance() {
        if (AmxBeaconListener.instance === undefined) {
            AmxBeaconListener.instance = new AmxBeaconListener();
        }
        return AmxBeaconListener.instance;
    }
    static isListening() {
        return AmxBeaconListener.getInstance().socket !== undefined;
    }
    static startListening() {
        return __awaiter(this, void 0, void 0, function* () {
            return AmxBeaconListener.getInstance().startListeningInternal();
        });
    }
    static stopListening() {
        return __awaiter(this, void 0, void 0, function* () {
            return AmxBeaconListener.getInstance().stopListeningInternal();
        });
    }
    errorCallback(error) {
        this.log.error(`udp error: ${error.message}`);
    }
    messageCallback(data) {
        const props = this.parseAmxBeacon(data.message);
        if (props === undefined || props.UUID === undefined) {
            if (debugBeacons) {
                this.log.debug(`invalid AMX beacon: ${data.message}`);
            }
        }
        else {
            if (debugBeacons) {
                this.log.debug(`received AMX beacon: ${data.message}`);
            }
            this.beacons[props.UUID] = {
                props,
                receiveTime: Date.now(),
            };
        }
        this.removeExpiredBeacons();
    }
    parseAmxBeacon(beacon) {
        if (!beacon.startsWith('AMXB'))
            return undefined;
        const props = {};
        const regExp = /<-(.+?)=(.+?)>/g;
        let match;
        while ((match = regExp.exec(beacon)) !== null) {
            props[match[1]] = match[2];
        }
        return props;
    }
    removeExpiredBeacons() {
        const old = Date.now() - 15 * 60 * 1000;
        for (const [key, beacon] of Object.entries(this.beacons)) {
            if (beacon.receiveTime < old) {
                delete this.beacons[key];
            }
        }
    }
    startListeningInternal() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.socket !== undefined) {
                this.log.warning(`startListening: already listening`);
                return;
            }
            this.socket = createUdpSocket();
            this.log.info(`startListening: created udp socket`);
            this.socket.onMessage(this.messageCallback);
            this.socket.onError(this.errorCallback);
            this.log.info(`startListening: binding udp socket to port ${amxBeaconPort}`);
            try {
                yield this.socket.bind(amxBeaconPort);
            }
            catch (error) {
                this.log.error(`startListening: bind failed: ${error}`);
                return;
            }
            this.log.info(`startListening: joining multicast group: ${amxBeaconMulticastAddress}`);
            try {
                yield this.socket.addMembership(amxBeaconMulticastAddress);
            }
            catch (error) {
                this.log.error(`startListening: addMembership failed: ${error}`);
                return;
            }
        });
    }
    stopListeningInternal() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.socket === undefined) {
                this.log.warning(`stopListening: not listening`);
                return;
            }
            this.socket.close();
            this.socket = undefined;
        });
    }
}
